import { Button, Col, Form, Input, Modal, Radio, Row, Select } from "antd";
import React, { Component } from "react";

const FormItem = Form.Item;
const { Option } = Select;
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

class UnwrappedAddMedicineModal extends Component {
  componentDidMount = () => {
    // console.log('Unwrapped Patient');
  };

  render() {
    const { visible, onCancel, onCreate, form, data, confirmLoading } =
      this.props;

    const { getFieldDecorator, getFieldValue } = form;

    const {
      name,
      packaging_use,
      prescription_required,
      price,
      salt,
      therapeutic_area,
    } = data;

    const form_tab = data.form;

    // console.log(data);

    // const form_tab = data.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 17 },
      },
    };

    const optionsInObject = [
      { key: "GRAMS-dental paste", value: "dental paste" },
      { key: "APPLICATION (PASTE)-orapaste", value: "orapaste" },
      { key: "APPLICATION (PASTE)-paste", value: "paste" },
      { key: "APPLICATION (PASTE)-toothpaste", value: "toothpaste" },
      { key: "BISCUIT-biscuit", value: "biscuit" },
      { key: "CAP-cap", value: "cap" },
      { key: "CAP-cap (lyo)", value: "cap (lyo)" },
      { key: "CAP-caplet", value: "caplet" },
      { key: "CAP-CR cap", value: "CR cap" },
      { key: "CAP-dispersible cap", value: "dispersible cap" },
      { key: "CAP-DP inhalation powd cap", value: "DP inhalation powd cap" },
      { key: "CAP-DR cap", value: "DR cap" },
      { key: "CAP-EC-CR cap", value: "EC-CR cap" },
      { key: "CAP-enteric-coated cap", value: "enteric-coated cap" },
      { key: "CAP-ER cap", value: "ER cap" },
      { key: "CAP-gastro-resistant cap", value: "gastro-resistant cap" },
      { key: "CAP-inhalation liqd cap", value: "inhalation liqd cap" },
      { key: "CAP-inhalation powd cap", value: "inhalation powd cap" },
      { key: "CAP-modified-release cap", value: "modified-release cap" },
      { key: "CAP-rectocap", value: "rectocap" },
      { key: "CAP-RES- cap", value: "RES- cap" },
      {
        key: "CAP-RESP- inhalation liqd cap",
        value: "RESP- inhalation liqd cap",
      },
      { key: "CAP-Respi- cap", value: "Respi- cap" },
      {
        key: "CAP-Respi- inhalation powd cap",
        value: "Respi- inhalation powd cap",
      },
      { key: "CAP-soft-gelatin cap", value: "soft-gelatin cap" },
      { key: "CAP-softgel", value: "softgel" },
      { key: "CAP-spansule", value: "spansule" },
      { key: "CAP-SR cap", value: "SR cap" },
      { key: "CAP-suscap", value: "suscap" },
      { key: "CAP-TR cap", value: "TR cap" },
      { key: "CAP-vag cap", value: "vag cap" },
      { key: "DOUCHE-vag douche", value: "vag douche" },
      { key: "DRESSING-dressing", value: "dressing" },
      { key: "DRESSING-Tulle Gras", value: "Tulle Gras" },
      { key: "ML-ear drops", value: "ear drops" },
      { key: "ML -eye drops", value: "eye drops" },
      { key: "ML -eye soln", value: "eye soln" },
      { key: "ML -eye susp", value: "eye susp" },
      { key: "ML -eye/ear drops", value: "eye/ear drops" },
      { key: "ML -eye/ear soln", value: "eye/ear soln" },
      { key: "ML-nasal drops", value: "nasal drops" },
      { key: "DROP-ophth soln", value: "ophth soln" },
      { key: "DROP-oral droplets", value: "oral droplets" },
      { key: "DROP-oral drops", value: "oral drops" },
      { key: "ML-P- nasal drops", value: "P- nasal drops" },
      { key: "ML-P- oral drops", value: "P- oral drops" },
      { key: "DURULE-durule", value: "durule" },
      { key: "FILM-film", value: "film" },
      { key: "GRAMS-balm", value: "balm" },
      { key: "GRAMS-cream", value: "cream" },
      { key: "GRAMS-dental gel", value: "dental gel" },
      { key: "PALM UNIT-DUST- topical powd", value: "DUST- topical powd" },
      { key: "GRAMS-eye gel", value: "eye gel" },
      { key: "GRAMS-eye lotion", value: "eye lotion" },
      { key: "GRAMS-eye oint", value: "eye oint" },
      {
        key: "PALM UNIT (LIQUID)-Face wash- topical gel",
        value: "Face wash- topical gel",
      },
      { key: "PALM UNIT (LIQUID)-Face- wash", value: "Face- wash" },
      { key: "GRAMS-jelly", value: "jelly" },
      { key: "FINGER TIP UNIT-mouth paint", value: "mouth paint" },
      { key: "GRAMS-nasal oint", value: "nasal oint" },
      { key: "FINGER TIP UNIT-oint", value: "oint" },
      { key: "PALM UNIT-ophth oint", value: "ophth oint" },
      { key: "GRAMS-oral gel", value: "oral gel" },
      { key: "FINGER TIP UNIT-paint", value: "paint" },
      { key: "PALM UNIT-rectal cream", value: "rectal cream" },
      { key: "PALM UNIT-rectal gel", value: "rectal gel" },
      { key: "PALM UNIT-rectal oint", value: "rectal oint" },
      { key: "PALM UNIT-rub", value: "rub" },
      { key: "PALM UNIT-topical gel", value: "topical gel" },
      { key: "PALM UNIT-topical powd", value: "topical powd" },
      { key: "PALM UNIT-vag cream", value: "vag cream" },
      { key: "PALM UNIT-vag gel", value: "vag gel" },
      { key: "PALM UNIT (FOAM)-foam", value: "foam" },
      { key: "PALM UNIT (LIQUID)-lotion", value: "lotion" },
      { key: "ML-nasal soln", value: "nasal soln" },
      { key: "PALM UNIT (LIQUID)-oil", value: "oil" },
      { key: "ML-oromucosal liqd", value: "oromucosal liqd" },
      { key: "ML-oromucosal soln", value: "oromucosal soln" },
      { key: "ML-rectal soln", value: "rectal soln" },
      {
        key: "PALM UNIT (LIQUID)-scalp application",
        value: "scalp application",
      },
      { key: "PALM UNIT (LIQUID)-scalp soln", value: "scalp soln" },
      {
        key: "PALM UNIT (LIQUID)-topical application",
        value: "topical application",
      },
      { key: "PALM UNIT (LIQUID)-topical emulsion", value: "topical emulsion" },
      { key: "PALM UNIT (LIQUID)-topical liqd", value: "topical liqd" },
      { key: "PALM UNIT (LIQUID)-topical oil", value: "topical oil" },
      { key: "PALM UNIT (LIQUID)-topical soln", value: "topical soln" },
      { key: "PALM UNIT (LIQUID)-vag soln", value: "vag soln" },
      { key: "PALM UNIT (LIQUID)-wash", value: "wash" },
      { key: "RINSE-dental soln", value: "dental soln" },
      { key: "RINSE-gargle", value: "gargle" },
      { key: "ML-mouthwash", value: "mouthwash" },
      {
        key: "TSP(GRAN)-granules for oral susp",
        value: "granules for oral susp",
      },
      { key: "INSERT-vag insert", value: "vag insert" },
      { key: "IUD-intra-uterine device", value: "intra-uterine device" },
      { key: "KIT-Combi- kit", value: "Combi- kit" },
      { key: "KIT-Compliance- kit", value: "Compliance- kit" },
      { key: "KIT-kit", value: "kit" },
      { key: "LOZ-loz", value: "loz" },
      { key: "MASK-facial mask", value: "facial mask" },
      { key: "MG-inhalant", value: "inhalant" },
      { key: "PALM UNIT (LIQUID)-bath oil", value: "bath oil" },
      { key: "ML-drink", value: "drink" },
      { key: "TSP-dry syr", value: "dry syr" },
      { key: "TSP-elixir", value: "elixir" },
      { key: "ML-emulsion for infusion", value: "emulsion for infusion" },
      { key: "ML-enema", value: "enema" },
      {
        key: "PALM UNIT (LIQUID)-Hair- topical oil",
        value: "Hair- topical oil",
      },
      { key: "TSP-linctus", value: "linctus" },
      { key: "TSP-liniment", value: "liniment" },
      { key: "PALM UNIT (LIQUID)-liqd soap", value: "liqd soap" },
      { key: "ML-nail lacquer", value: "nail lacquer" },
      { key: "ML-nebuliser soln", value: "nebuliser soln" },
      { key: "TSP-ophth susp", value: "ophth susp" },
      { key: "TSP-oral emulsion", value: "oral emulsion" },
      { key: "TSP-oral liqd", value: "oral liqd" },
      { key: "TSP-oral soln", value: "oral soln" },
      { key: "TSP-oral susp", value: "oral susp" },
      { key: "TSP-P- dry syr", value: "P- dry syr" },
      { key: "TSP-P- elixir", value: "P- elixir" },
      { key: "TSP-P- oral liqd", value: "P- oral liqd" },
      { key: "TSP-P- oral susp", value: "P- oral susp" },
      { key: "TSP-P- syr", value: "P- syr" },
      { key: "TSP-powd for oral liqd", value: "powd for oral liqd" },
      { key: "TSP, SCOOP-powd for oral soln", value: "powd for oral soln" },
      { key: "TSP-powd for oral susp", value: "powd for oral susp" },
      { key: "TSP-respules", value: "respules" },
      { key: "PALM UNIT (LIQUID)-shampoo", value: "shampoo" },
      { key: "TSP-syr", value: "syr" },
      { key: "OVULE-ovule", value: "ovule" },
      { key: "PACK-Hair tinct", value: "Hair tinct" },
      { key: "PACK-scrub", value: "scrub" },
      { key: "PACK-soap", value: "soap" },
      { key: "PACK-Surgical scrub", value: "Surgical scrub" },
      { key: "PATCH-dermal patch", value: "dermal patch" },
      { key: "PATCH-transdermal patch", value: "transdermal patch" },
      { key: "PELLET-pellets", value: "pellets" },
      { key: "PESSARY-pessary", value: "pessary" },
      { key: "PILL-pill", value: "pill" },
      { key: "PLASTER-plaster", value: "plaster" },
      { key: "PUFF (MD)-accuhaler", value: "accuhaler" },
      { key: "PUFF (MD)-autohaler", value: "autohaler" },
      { key: "PUFF (MD)-evohaler", value: "evohaler" },
      { key: "PUFF (MD)-inhalation soln", value: "inhalation soln" },
      { key: "PUFF (MD)-inhaler", value: "inhaler" },
      { key: "PUFF (MD)-MDI", value: "MDI" },
      {
        key: "PUFF (MD)-powd for inhalation soln",
        value: "powd for inhalation soln",
      },
      { key: "ROTACAP-rotacap", value: "rotacap" },
      { key: "SACHET-granules for oral soln", value: "granules for oral soln" },
      { key: "SOAP-bar soap", value: "bar soap" },
      { key: "SPRAY-aerosol", value: "aerosol" },
      { key: "SPRAY-aerosol spray", value: "aerosol spray" },
      { key: "SPRAY-nasal aerosol", value: "nasal aerosol" },
      { key: "SPRAY-nasal spray", value: "nasal spray" },
      { key: "SPRAY-oromucosal spray", value: "oromucosal spray" },
      { key: "SPRAY-topical spray", value: "topical spray" },
      { key: "SUPP-supp", value: "supp" },
      { key: "SUPP-vag supp", value: "vag supp" },
      { key: "TAB-bilayer coated tab", value: "bilayer coated tab" },
      { key: "TAB-captab", value: "captab" },
      { key: "TAB-chewable tab", value: "chewable tab" },
      { key: "TAB-chewtab", value: "chewtab" },
      { key: "TAB-coated tab", value: "coated tab" },
      { key: "TAB-CR tab", value: "CR tab" },
      { key: "TAB-dispertab", value: "dispertab" },
      { key: "TAB-DR tab", value: "DR tab" },
      { key: "TAB-DR-FC tab", value: "DR-FC tab" },
      { key: "TAB-drag", value: "drag" },
      { key: "TAB-effervescent tab", value: "effervescent tab" },
      { key: "TAB-enteric film-coated tab", value: "enteric film-coated tab" },
      { key: "TAB-enteric-coated tab", value: "enteric-coated tab" },
      { key: "TAB-ER tab", value: "ER tab" },
      { key: "TAB-ER- vag tab", value: "ER- vag tab" },
      { key: "TAB-extentab", value: "extentab" },
      { key: "TAB-FC- captab", value: "FC- captab" },
      { key: "TAB-filcotab", value: "filcotab" },
      { key: "TAB-film-coated tab", value: "film-coated tab" },
      { key: "TAB-filmtab", value: "filmtab" },
      { key: "TAB-gastro-resistant tab", value: "gastro-resistant tab" },
      { key: "TAB-gelatin-coated tab", value: "gelatin-coated tab" },
      { key: "TAB-IR tab", value: "IR tab" },
      {
        key: "TAB-MD- modified-release tab",
        value: "MD- modified-release tab",
      },
      { key: "TAB-MD- tab", value: "MD- tab" },
      {
        key: "TAB-MELT- modified-release tab",
        value: "MELT- modified-release tab",
      },
      { key: "TAB-MELT- tab", value: "MELT- tab" },
      { key: "TAB-modified-release tab", value: "modified-release tab" },
      {
        key: "TAB-orally disintegrating tab",
        value: "orally disintegrating tab",
      },
      { key: "TAB-orodispersible tab", value: "orodispersible tab" },
      { key: "TAB-P- dispertab", value: "P- dispertab" },
      { key: "TAB-P- film-coated tab", value: "P- film-coated tab" },
      { key: "TAB-P- tab", value: "P- tab" },
      { key: "TAB-PR tab", value: "PR tab" },
      { key: "TAB-retard tab", value: "retard tab" },
      { key: "TAB-SR tab", value: "SR tab" },
      { key: "TAB-SR-FC tab", value: "SR-FC tab" },
      { key: "TAB-sublingual tab", value: "sublingual tab" },
      { key: "TAB-sugar-coated tab", value: "sugar-coated tab" },
      { key: "TAB-tab", value: "tab" },
      { key: "TAB-TR tab", value: "TR tab" },
      { key: "TAB-vag tab", value: "vag tab" },
      { key: "TAB-XR tab", value: "XR tab" },
      { key: "TSP(GRAN)-EC granules", value: "EC granules" },
      { key: "TSP(GRAN)-oral granules", value: "oral granules" },
      { key: "UNITS,ML,INJ,G,MG,MCG-depot inj", value: "depot inj" },
      { key: "UNITS,ML,INJ,G,MG,MCG-FlexPen", value: "FlexPen" },
      { key: "UNITS,ML,INJ,G,MG,MCG-infusion", value: "infusion" },
      { key: "UNITS,ML,INJ,G,MG,MCG-infusion conc", value: "infusion conc" },
      { key: "UNITS,ML,INJ,G,MG,MCG-inj", value: "inj" },
      {
        key: "UNITS,ML,INJ,G,MG,MCG-inj (lyo) for soln",
        value: "inj (lyo) for soln",
      },
      {
        key: "UNITS,ML,INJ,G,MG,MCG-inj (pre-filled)",
        value: "inj (pre-filled)",
      },
      { key: "UNITS,ML,INJ,G,MG,MCG-inj conc", value: "inj conc" },
      {
        key: "UNITS,ML,INJ,G,MG,MCG-intraocular inj",
        value: "intraocular inj",
      },
      {
        key: "UNITS,ML,INJ,G,MG,MCG-lipid complex inj",
        value: "lipid complex inj",
      },
      { key: "UNITS,ML,INJ,G,MG,MCG-liposomal inj", value: "liposomal inj" },
      {
        key: "UNITS,ML,INJ,G,MG,MCG-Neonate- powd for inj",
        value: "Neonate- powd for inj",
      },
      { key: "UNITS,ML,INJ,G,MG,MCG-Novolet", value: "Novolet" },
      { key: "UNITS,ML,INJ,G,MG,MCG-OptiPen", value: "OptiPen" },
      { key: "UNITS,ML,INJ,G,MG,MCG-P- inj", value: "P- inj" },
      {
        key: "UNITS,ML,INJ,G,MG,MCG-P- powd for inj",
        value: "P- powd for inj",
      },
      { key: "UNITS,ML,INJ,G,MG,MCG-penfill", value: "penfill" },
      { key: "UNITS,ML,INJ,G,MG,MCG-powd for inj", value: "powd for inj" },
      { key: "UNITS,ML,INJ,G,MG,MCG-pre-filled inj", value: "pre-filled inj" },
      { key: "UNITS,ML,INJ,G,MG,MCG-pre-filled pen", value: "pre-filled pen" },
      {
        key: "UNITS,ML,INJ,G,MG,MCG-pre-filled syringe",
        value: "pre-filled syringe",
      },
      { key: "UNITS,ML,INJ,G,MG,MCG-susp for inj", value: "susp for inj" },
      { key: "UNITS,ML,INJ,G,MG,MCG-vaccine (inj)", value: "vaccine (inj)" },
      { key: "VACCINE-vaccine (oral)", value: "vaccine (oral)" },
      { key: "WAFER-wafer", value: "wafer" },
      { key: "WIPE-wipe", value: "wipe" },
    ];

    const unitMaps = {
      accuhaler: ["PUFF (MD)"],
      aerosol: ["SPRAY"],
      "aerosol spray": ["SPRAY"],
      autohaler: ["PUFF (MD)"],
      balm: ["APPLICATION (1 FTU)"],
      "bar soap": [""],
      "bath oil": ["APPLICATION (OIL) "],
      "bilayer coated tab": ["TAB"],
      biscuit: ["BISCUIT"],
      cap: ["CAP"],
      "cap (lyo)": ["CAP"],
      caplet: ["CAP"],
      captab: ["TAB"],
      "chewable tab": ["TAB"],
      chewtab: ["TAB"],
      "coated tab": ["TAB"],
      "Combi- kit": ["KIT"],
      "Compliance- kit": ["KIT"],
      "CR cap": ["CAP"],
      "CR tab": ["TAB"],
      cream: ["APPLICATION (1 FTU)"],
      "dental gel": ["APPLICATION (1 FTU)"],
      "dental paste": ["APPLICATION (PASTE)"],
      "dental soln": ["GARGLE"],
      "depot inj": ["UNITS", "ML", "INJ", "G", "MG", "MCG"],
      "dermal patch": ["PATCH"],
      "dispersible cap": ["CAP"],
      dispertab: ["TAB"],
      "DP inhalation powd cap": ["CAP"],
      "DR cap": ["CAP"],
      "DR tab": ["TAB"],
      "DR-FC tab": ["TAB"],
      drag: ["TAB"],
      dressing: ["DRESSING"],
      drink: ["DRINK"],
      "dry syr": ["TBSP"],
      durule: ["DURULE"],
      "DUST- topical powd": [""],
      "ear drops": ["DROP"],
      "EC granules": ["TBSP(GRAN)"],
      "EC-CR cap": ["CAP"],
      "effervescent tab": ["TAB"],
      elixir: ["TBSP"],
      "emulsion for infusion": ["ML"],
      enema: ["ML"],
      "enteric film-coated tab": ["TAB"],
      "enteric-coated cap": ["CAP"],
      "enteric-coated tab": ["TAB"],
      "ER cap": ["CAP"],
      "ER tab": ["TAB"],
      "ER- vag tab": ["TAB"],
      evohaler: ["PUFF (MD)"],
      extentab: ["TAB"],
      "eye drops": ["DROP"],
      "eye gel": ["APPLICATION (1 FTU)"],
      "eye lotion": ["APPLICATION (1 FTU)"],
      "eye oint": ["APPLICATION (1 FTU)"],
      "eye soln": ["DROP"],
      "eye susp": ["DROP"],
      "eye/ear drops": ["DROP"],
      "eye/ear soln": ["DROP"],
      "Face wash- topical gel": ["APPLICATION (1 FTU)"],
      "Face- wash": [""],
      "facial mask": [""],
      "FC- captab": ["TAB"],
      filcotab: ["TAB"],
      film: ["FILM"],
      "film-coated tab": ["TAB"],
      filmtab: ["TAB"],
      FlexPen: ["UNITS", "ML", "INJ", "G", "MG", "MCG"],
      foam: [""],
      gargle: ["GARGLE"],
      "gastro-resistant cap": ["CAP"],
      "gastro-resistant tab": ["TAB"],
      "gelatin-coated tab": ["TAB"],
      "granules for oral susp": ["TBSP(GRAN)"],
      "Hair tinct": [""],
      "Hair- topical oil": ["ML & APPLICATION (OIL)"],
      infusion: ["UNITS", "ML", "INJ", "G", "MG", "MCG"],
      "infusion conc": ["UNITS", "ML", "INJ", "G", "MG", "MCG"],
      inhalant: ["MCG"],
      "inhalation liqd cap": ["CAP"],
      "inhalation powd cap": ["CAP"],
      "inhalation soln": ["PUFF (MD)"],
      inhaler: ["PUFF (MD)"],
      inj: ["UNITS", "ML", "INJ", "G", "MG", "MCG"],
      "inj (lyo) for soln": ["UNITS", "ML", "INJ", "G", "MG", "MCG"],
      "inj (pre-filled)": ["UNITS", "ML", "INJ", "G", "MG", "MCG"],
      "inj conc": ["UNITS", "ML", "INJ", "G", "MG", "MCG"],
      "intra-uterine device": ["IUD"],
      "intraocular inj": ["UNITS", "ML", "INJ", "G", "MG", "MCG"],
      "IR tab": ["TAB"],
      jelly: ["APPLICATION (1 FTU)"],
      kit: ["KIT"],
      linctus: ["TBSP"],
      liniment: ["TSP & TBSP"],
      "lipid complex inj": ["UNITS", "ML", "INJ", "G", "MG", "MCG"],
      "liposomal inj": ["UNITS", "ML", "INJ", "G", "MG", "MCG"],
      "liqd soap": [""],
      lotion: [""],
      loz: ["LOZ"],
      "MD- modified-release tab": ["TAB"],
      "MD- tab": ["TAB"],
      MDI: ["PUFF (MD)"],
      "MELT- modified-release tab": ["TAB"],
      "MELT- tab": ["TAB"],
      "modified-release cap": ["CAP"],
      "modified-release tab": ["TAB"],
      "mouth paint": ["APPLICATION (1 FTU)"],
      mouthwash: ["GARGLE"],
      "nail lacquer": [""],
      "nasal aerosol": ["SPRAY"],
      "nasal drops": ["DROP"],
      "nasal oint": ["APPLICATION (1 FTU)"],
      "nasal soln": [""],
      "nasal spray": ["SPRAY"],
      "nebuliser soln": ["ML"],
      "Neonate- powd for inj": ["UNITS", "ML", "INJ", "G", "MG", "MCG"],
      Novolet: ["UNITS", "ML", "INJ", "G", "MG", "MCG"],
      oil: ["ML"],
      oint: ["APPLICATION (1 FTU)"],
      "ophth oint": ["APPLICATION (1 FTU)"],
      "ophth soln": ["DROP"],
      "ophth susp": ["ML"],
      OptiPen: ["UNITS", "ML", "INJ", "G", "MG", "MCG"],
      "oral droplets": ["DROP"],
      "oral drops": ["DROP"],
      "oral emulsion": ["TSP", "TBSP"],
      "oral gel": ["APPLICATION (1 FTU)"],
      "oral granules": ["TBSP(GRAN)"],
      "oral liqd": ["TBSP", "ML"],
      "oral soln": ["TBSP"],
      "oral susp": ["TBSP"],
      "orally disintegrating tab": ["TAB"],
      orapaste: ["APPLICATION (PASTE)"],
      "orodispersible tab": ["TAB"],
      "oromucosal liqd": ["ML"],
      "oromucosal soln": ["APPLICATION FTU LIQUID"],
      "oromucosal spray": ["SPRAY"],
      ovule: ["OVULE"],
      "P- dispertab": ["TAB"],
      "P- dry syr": ["TBSP"],
      "P- elixir": ["TBSP"],
      "P- film-coated tab": ["TAB"],
      "P- inj": ["UNITS", "ML", "INJ", "G", "MG", "MCG"],
      "P- nasal drops": ["DROP"],
      "P- oral drops": ["DROP"],
      "P- oral liqd": ["TBSP"],
      "P- oral susp": ["TSP & TBSP"],
      "P- powd for inj": ["UNITS", "ML", "INJ", "G", "MG", "MCG"],
      "P- syr": ["TSP", "TBSP"],
      "P- tab": ["TAB"],
      paint: ["APPLICATION (1 FTU)"],
      paste: ["APPLICATION (PASTE)"],
      pellets: ["PELLET"],
      penfill: ["UNITS", "ML", "INJ", "G", "MG", "MCG"],
      pessary: ["PESSARY"],
      pill: ["PILL"],
      plaster: ["PLASTER"],
      "powd for inhalation soln": ["PUFF (MD)"],
      "powd for inj": ["UNITS", "ML", "INJ", "G", "MG", "MCG"],
      "powd for oral liqd": ["TBSP"],
      "powd for oral soln": ["TBSP"],
      "powd for oral susp": ["TBSP"],
      "PR tab": ["TAB"],
      "pre-filled inj": ["UNITS", "ML", "INJ", "G", "MG", "MCG"],
      "pre-filled pen": ["UNITS", "ML", "INJ", "G", "MG", "MCG"],
      "pre-filled syringe": ["UNITS", "ML", "INJ", "G", "MG", "MCG"],
      "rectal cream": ["APPLICATION (1 FTU)"],
      "rectal gel": ["APPLICATION (1 FTU)"],
      "rectal oint": ["APPLICATION (1 FTU)"],
      "rectal soln": ["ML"],
      rectocap: ["CAP"],
      "RES- cap": ["CAP"],
      "RESP- inhalation liqd cap": ["CAP"],
      "Respi- cap": ["CAP"],
      "Respi- inhalation powd cap": ["CAP"],
      respules: ["TSP"],
      "retard tab": ["TAB"],
      rotacap: ["ROTACAP"],
      rub: ["APPLICATION (1 FTU)"],
      "scalp application": [""],
      "scalp soln": ["ML"],
      scrub: [""],
      shampoo: ["ML"],
      soap: [""],
      "soft-gelatin cap": ["CAP"],
      softgel: ["CAP"],
      spansule: ["CAP"],
      "SR cap": ["CAP"],
      "SR tab": ["TAB"],
      "SR-FC tab": ["TAB"],
      "sublingual tab": ["TAB"],
      "sugar-coated tab": ["TAB"],
      supp: ["SUPP"],
      "Surgical scrub": [""],
      suscap: ["CAP"],
      "susp for inj": ["UNITS", "ML", "INJ", "G", "MG", "MCG"],
      syr: ["TBSP"],
      tab: ["TAB"],
      toothpaste: ["APPLICATION (PASTE)"],
      "topical application": ["ML"],
      "topical emulsion": [""],
      "topical gel": ["APPLICATION (1 FTU)"],
      "topical liqd": [""],
      "topical oil": ["ML & APPLICATION (OIL)"],
      "topical powd": [""],
      "topical soln": [""],
      "topical spray": ["SPRAY"],
      "TR cap": ["CAP"],
      "TR tab": ["TAB"],
      "transdermal patch": ["PATCH"],
      "Tulle Gras": ["DRESSING"],
      "vaccine (inj)": ["UNITS", "ML", "INJ", "G", "MG", "MCG"],
      "vaccine (oral)": ["VACCINE"],
      "vag cap": ["CAP"],
      "vag cream": ["APPLICATION (1 FTU)"],
      "vag douche": ["DOUCHE"],
      "vag gel": ["APPLICATION (1 FTU)"],
      "vag insert": ["INSERT"],
      "vag soln": ["APPLICATION FTU LIQUID"],
      "vag supp": ["SUPP"],
      "vag tab": ["TAB"],
      wafer: ["WAFER"],
      wash: [""],
      wipe: ["WIPE"],
      "XR tab": ["TAB"],
      "granules for oral soln": ["SACHET"],
    };

    const fromObject =
      unitMaps[getFieldValue("form")] == null
        ? []
        : unitMaps[getFieldValue("form")];

    let unitOptions;

    if (fromObject.length > 0) {
      unitOptions = fromObject.map((obj) => (
        <Option key={obj} value={obj}>
          {obj}
        </Option>
      ));
    } else {
      const units = [
        "ML",
        "FTU",
        "DROP",
        "SPRAY",
        "TSP",
        "TBSP",
        "30ML",
        "U",
        "MG",
        "SACHET",
        "SCOOP",
      ];
      unitOptions = units.map((obj) => (
        <Option key={obj} value={obj}>
          {obj}
        </Option>
      ));
    }

    const suffixSelector = getFieldDecorator("unit", {
      initialValue: unitOptions.length === 1 ? unitOptions[0].props.value : "",
    })(<Select style={{ width: 70 }}>{unitOptions}</Select>);

    const options = optionsInObject.map((option, index) => (
      <Option value={option.value} key={index}>
        {option.key}
      </Option>
    ));

    return (
      <Modal
        visible={visible}
        title={data === {} ? "Add new Medicine" : "Edit Medicine"}
        style={{ textAlign: "center", fontSize: "1.2em", top: 20 }}
        width="40%"
        okText="Submit"
        onCancel={onCancel}
        // onOk={onCreate}
        footer={[
          <Button key="cancel" onClick={onCancel}>
            Return
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={confirmLoading}
            onClick={onCreate}
          >
            Submit
          </Button>,
        ]}
      >
        <Form>
          <div style={{ height: "580px", overflow: "auto" }}>
            {/* Name */}

            <FormItem {...formItemLayout} label="Name">
              {getFieldDecorator("name", {
                rules: [{ required: true, message: "Name of the medicine?" }],
                initialValue: name,
              })(<Input />)}
            </FormItem>

            {/* Strength */}

            {/* <FormItem
                            {...formItemLayout}
                            label="Strength"
                        >
                            {getFieldDecorator('strength', {
                                rules: [{ required: false, message: 'First Name of the Patient!' }],
                                // initialValue: ailment !== 'NULL' ? ailment : '',
                            })(
                                <Input />,
                            )}
                        </FormItem> */}

            {/* Form */}

            <FormItem {...formItemLayout} label="Form">
              {getFieldDecorator("form", {
                rules: [{ required: true, message: "What's the type of med?" }],
                initialValue: form_tab !== "NULL" ? form_tab : "",
              })(
                <Select
                  showSearch
                  mode="combobox"
                  placeholder="Select a form"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {options}
                </Select>
              )}
            </FormItem>

            {/* Pack of  */}

            <FormItem {...formItemLayout} label="Pack Of">
              {getFieldDecorator("packaging_use", {
                rules: [
                  { required: false, message: "Last Name of the Patient!" },
                ],
                initialValue: packaging_use !== "NULL" ? packaging_use : "",
              })(<Input addonAfter={suffixSelector} />)}
            </FormItem>

            {/* Price */}

            <FormItem {...formItemLayout} label="Price">
              {getFieldDecorator("price", {
                rules: [
                  { required: false, message: "Last Name of the Patient!" },
                ],
                initialValue: price !== "NULL" ? price : "",
              })(<Input />)}
            </FormItem>

            {/* Manufacturer */}

            {/* <FormItem
                            { ...formItemLayout }
                            label="Manufacturer"
                        >
                            {getFieldDecorator('manufacturer', {
                                rules: [{ required: true, message: 'Name of Manufacturer?' }],
                                initialValue: manufacturer !== 'NULL' ? manufacturer : '',
                            })(
                                // <Select
                                //     showSearch
                                //     value={this.state.selectedValue}
                                //     placeholder="Manufacturer"
                                //     style={{width: '40%'}}
                                //     defaultActiveFirstOption={false}
                                //     showArrow={false}
                                //     filterOption={false}
                                //     // onSearch={this.handleSearchManufacturer}
                                //     // onChange={this.handleChangeManufacturer}
                                //     // onSelect={this.handleMedSelect}
                                //     notFoundContent={this.state.fetching ? <Spin size="small" /> : null}
                                // >
                                //     {options}
                                // </Select>
                            )}
                        </FormItem> */}

            {/* Therapeutic Area */}

            <FormItem {...formItemLayout} label="Therapeutic Area">
              {getFieldDecorator("therapeutic_area", {
                rules: [
                  { required: false, message: "Last Name of the Patient!" },
                ],
                initialValue:
                  therapeutic_area !== "NULL" ? therapeutic_area : "",
              })(<Input />)}
            </FormItem>

            {/* Manufacturer */}

            <FormItem {...formItemLayout} label="Manufacturer">
              {getFieldDecorator("manufacturer", {
                rules: [
                  { required: false, message: "Last Name of the Patient!" },
                ],
                initialValue:
                  therapeutic_area !== "NULL" ? therapeutic_area : "",
              })(<Input />)}
            </FormItem>

            {/* Prescription Required */}

            <FormItem {...formItemLayout} label="Rx Required">
              {getFieldDecorator("prescription_required", {
                rules: [
                  { required: true, message: "Is prescription necessary?" },
                ],
                initialValue: prescription_required ? "yes" : "no",
              })(
                <RadioGroup>
                  <RadioButton value="yes">Yes</RadioButton>
                  <RadioButton value="no">No</RadioButton>
                </RadioGroup>
              )}
            </FormItem>

            {/* Can be caredosed */}

            <FormItem {...formItemLayout} label="Caredosable">
              {getFieldDecorator("caredosable", {
                rules: [
                  {
                    required: false,
                    message: "Please select the sex of patient!",
                  },
                ],
                // initialValue: is_cut,
              })(
                <RadioGroup>
                  <RadioButton value="yes">Yes</RadioButton>
                  <RadioButton value="no">No</RadioButton>
                </RadioGroup>
              )}
            </FormItem>

            {/* Salt */}

            <FormItem {...formItemLayout} label="Salt">
              {getFieldDecorator("salt", {
                rules: [{ required: true, message: "What's the salt YO!" }],
                initialValue: salt,
              })(<Input />)}
            </FormItem>

            {/* Volumetric analysis */}

            <div>
              <h6 style={{ textAlign: "center" }}> Dimensions </h6>
              <hr width="100" />
            </div>

            <Row type="flex" justify="space-around">
              <Col span={9}>H</Col>
              <Col span={7}>W</Col>
              <Col span={8}>L</Col>
            </Row>

            <Row type="flex" justify="space-between">
              <Col span={8}>
                <FormItem {...formItemLayout} label="Strip">
                  {getFieldDecorator("strip_height", {
                    rules: [
                      { required: false, message: "Last Name of the Patient!" },
                    ],
                    // initialValue: strip_height,
                  })(<Input style={{ width: "90%" }} />)}
                </FormItem>
              </Col>

              <Col span={7}>
                <FormItem>
                  {getFieldDecorator("strip_width", {
                    rules: [
                      { required: false, message: "Last Name of the Patient!" },
                    ],
                    // initialValue: strip_height,
                  })(<Input style={{ width: "80%" }} />)}
                </FormItem>
              </Col>

              <Col span={7}>
                <FormItem>
                  {getFieldDecorator("strip_length", {
                    rules: [
                      { required: false, message: "Last Name of the Patient!" },
                    ],
                    // initialValue: strip_height,
                  })(<Input style={{ width: "80%" }} />)}
                </FormItem>
              </Col>
            </Row>

            <Row type="flex" justify="space-between">
              <Col span={8}>
                <FormItem {...formItemLayout} label="Center">
                  {getFieldDecorator("center_height", {
                    rules: [
                      { required: false, message: "Last Name of the Patient!" },
                    ],
                    // initialValue: strip_height,
                  })(<Input style={{ width: "90%" }} disabled />)}
                </FormItem>
              </Col>

              <Col span={7}>
                <FormItem>
                  {getFieldDecorator("center_width", {
                    rules: [
                      { required: false, message: "Last Name of the Patient!" },
                    ],
                    // initialValue: strip_height,
                  })(<Input style={{ width: "80%" }} />)}
                </FormItem>
              </Col>

              <Col span={7}>
                <FormItem>
                  {getFieldDecorator("center_length", {
                    rules: [
                      { required: false, message: "Last Name of the Patient!" },
                    ],
                    // initialValue: strip_height,
                  })(<Input style={{ width: "80%" }} />)}
                </FormItem>
              </Col>
            </Row>

            <Row type="flex" justify="space-between">
              <Col span={8}>
                <FormItem {...formItemLayout} label="Side">
                  {getFieldDecorator("side_height", {
                    rules: [
                      { required: false, message: "Last Name of the Patient!" },
                    ],
                    // initialValue: strip_height,
                  })(<Input style={{ width: "90%" }} disabled />)}
                </FormItem>
              </Col>

              <Col span={7}>
                <FormItem>
                  {getFieldDecorator("side_width", {
                    rules: [
                      { required: false, message: "Last Name of the Patient!" },
                    ],
                    // initialValue: strip_height,
                  })(<Input style={{ width: "80%" }} />)}
                </FormItem>
              </Col>

              <Col span={7}>
                <FormItem>
                  {getFieldDecorator("side_length", {
                    rules: [
                      { required: false, message: "Last Name of the Patient!" },
                    ],
                    // initialValue: strip_height,
                  })(<Input style={{ width: "80%" }} />)}
                </FormItem>
              </Col>
            </Row>

            {/* <FormItem
                            { ...formItemLayout }
                            label="Dim Strip"
                        >
                            {getFieldDecorator('dim_strip', {
                                rules: [{ required: false, message: 'Last Name of the Patient!' }],
                                initialValue: dim_strip,
                            })(
                                <Input />
                            )}
                        </FormItem>

                        <FormItem
                            { ...formItemLayout }
                            label="Dim Unit Corner"
                        >
                            {getFieldDecorator('dim_unit_corner', {
                                rules: [{ required: false, message: 'Last Name of the Patient!' }],
                                initialValue: dim_unit_corner,
                            })(
                                <Input />
                            )}
                        </FormItem>

                        <FormItem
                            { ...formItemLayout }
                            label="Dim Unit Center"
                        >
                            {getFieldDecorator('dim_unit_center', {
                                rules: [{ required: false, message: 'Last Name of the Patient!' }],
                                initialValue: dim_unit_center,
                            })(
                                <Input />
                            )}
                        </FormItem>

                        <FormItem
                            { ...formItemLayout }
                            label="Dim Unit Side"
                        >
                            {getFieldDecorator('dim_unit_side', {
                                rules: [{ required: false, message: 'Last Name of the Patient!' }],
                                initialValue: dim_unit_side,
                            })(
                                <Input />
                            )}
                        </FormItem>

                        <FormItem
                            { ...formItemLayout }
                            label="Dim Unit Height"
                        >
                            {getFieldDecorator('dim_unit_height', {
                                rules: [{ required: false, message: 'Last Name of the Patient!' }],
                                initialValue: dim_unit_height,
                            })(
                                <Input />
                            )}
                        </FormItem> */}

            {/* Volumetric analysis */}
          </div>
        </Form>
      </Modal>
    );
  }
}

const AddMedicineModal = Form.create()(UnwrappedAddMedicineModal);

export default AddMedicineModal;



// WEBPACK FOOTER //
// ./src/component/AllMedicines/AddMedicineModal.js